import { render, staticRenderFns } from "./chatDetail.vue?vue&type=template&id=0c7c6832&scoped=true&"
import script from "./chatDetail.vue?vue&type=script&lang=js&"
export * from "./chatDetail.vue?vue&type=script&lang=js&"
import style0 from "./chatDetail.vue?vue&type=style&index=0&id=0c7c6832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7c6832",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c7c6832')) {
      api.createRecord('0c7c6832', component.options)
    } else {
      api.reload('0c7c6832', component.options)
    }
    module.hot.accept("./chatDetail.vue?vue&type=template&id=0c7c6832&scoped=true&", function () {
      api.rerender('0c7c6832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/analysisChatManagement/components/chatDetail.vue"
export default component.exports